import { useEffect, useRef } from "react";
import { useParticipantTracks } from "@livekit/components-react";
import type { TrackPublication } from "livekit-client";
import { Track } from "livekit-client";
import type { Peer } from "@/react/types/Live/Peer";

export const useLivekitPeerVideo = (peer?: Peer) => {
  const trackRefs = useParticipantTracks([Track.Source.Camera], peer?.id);
  const cameraPublication: TrackPublication = trackRefs[0]?.publication;
  const track = cameraPublication?.track;

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const videoElement = videoRef.current;
  const hasVideo =
    cameraPublication?.isSubscribed && !cameraPublication?.isMuted;

  useEffect(() => {
    if (videoElement && track) {
      if (hasVideo) {
        track.attach(videoElement);
      } else {
        track.detach(videoElement);
      }
    }

    return () => {
      if (videoElement && track) {
        track.detach(videoElement);
      }
    };
  }, [videoElement, track, hasVideo]);

  return {
    videoRef,
    hasVideo,
  };
};
